import * as imageConstants from './ImageConstants';
import { store_netbankingObject } from '../stores/OrderStore';

export const SpecialCharacters = {
  rupee: '\u20B9',
};
export const jwtTokenCleanupSource = {
  iframe: 'iframe',
  merchant: 'merchant',
};

export const VITE_STALE_KWIK_SESSION_TOKENS = 'pdp.gokwik.co,.pdp.gokwik.co';
export const Address = {
  title: 'Delivering to',
  address: 'Address',
  shippingHeader: 'Shipping Address',
  addAddress: 'Add Delivery Address',
  tagHome: 'Home',
  tagWork: 'Work',
  editAddress: 'Edit Address',
  listingHeader: 'Select Delivery Address',
  listingSubHeading: 'Select the address where you want to ship your products',
  enterPincode: 'Enter your Pincode',
  addLandmark: 'Add Landmark and Alternate Mobile Number',
  addBtnText: '+ Add address',
  longAddress: 'Address is too long! Keep it under 255 characters.',
  partialAddress: 'Address seems incorrect! Fill in the missing details.',
  partialAddressName: 'Name seems incorrect! Enter your full name to proceed.',
  partialAddressPincode: 'Invalid pincode! Enter a valid 6-digit pincode.',
  nonNumericInfo: 'Please enter the complete address for smooth delivery.',
  invalidEmail: 'Please update your email address',
  messages: {
    shippingContinueFailed: `Looks like we're not delivering to this location right now. Try picking another address or add a new one.`,
    addressUpdatedSuccessfully: 'Your address has been successfully updated.',
    addressAddedSuccessfully: 'Your new address has been updated successfully.',
    cityEmpty: 'City is missing! Enter city name to proceed.',
    cityLenghExceedErr: 'City name is too long! Keep it under 30 characters.',
    pincodeEmpty: 'Pincode is missing! Enter valid Pincode to proceed.',
    fullNameError: 'Enter your full name to proceed.',
    firstNameError: 'Please enter your first name to proceed.',
    nameTooShort: 'Name is too short! Use at least 3 alphabets.',
    emailError: 'Invalid Email ID. Please enter a valid email ID',
    emailEmptyError: 'E-mail is mandatory. Please enter your e-mail ID to continue',
    fullAddressError: 'Address is too short! Enter full address to proceed.',
    fullAddressExceedError: 'Address is too long! Keep it under 255 characters.',
    boatEmailError: 'Invalid email added. Please change email to proceed',
    shortPincode: 'Your pincode length is lesser than 6 characters. Please enter a proper pincode to continue',
    shippingMethodError: 'Please select shipping method',
    codRedirect: 'Redirecting to other payment modes',
    recipientPhoneInvalid: 'Please enter a valid phone number',
  },
};
export const Header = {
  mobile: 'Mobile',
  address: 'Address',
  pay: 'Payment',
};
export const Common = {
  addNew: 'Add New',
  keepUpdated: 'Allow us to alerts on',
  alertWith: 'WhatsApp, email & others',
  proceedTandC: 'By proceeding you accept our',
  tandC: 'Terms and Conditions',
};

export const MobileNumber = {
  enterPhone: 'Enter your mobile number',
  countryCode: ' +91',
  otpPageMessage: 'We can help prefill your address',
  orderOtpMessage: 'Help us verify your order',
  enterOtp: 'Enter OTP sent to',
  resendOtp: 'Resend OTP in',
  orderOtp: 'Enter OTP sent to ',
  messages: {
    invalidPhoneNumber: 'Invalid phone number! Enter a valid number to proceed.',
  },
  truecallerError: 'Couldn’t fetch details! Enter manually to proceed.',
  whatsappOTP: 'Receive OTP on Whatsapp',
  whatsappOTPSucess: 'OTP sent on Whatsapp successfully.',
  verify: 'Verify mobile number',
  addressFound: 'We found your address',
};

export const ShopingBag = {
  title: 'Products in Shopping Bag',
};
export const OrderSummary = {
  title: 'Show order summary',
  item: 'Item',
  tax: 'Tax',
  totalDiscount: 'Total Discount',
  shipping: 'Shipping',
  total: 'Total',
  cartProperty: [
    'Enter Text',
    'Front Text',
    'Back Text',
    'Text',
    'Embroidery Color',
    'Emoji 1',
    'Emoji 1 Alignment',
    'Emoji 2',
    'Emoji 2 Alignment',
    'Font Style',
    'Font',
    'Customise-Charge',
    'Name ',
    'Name',
    'Number',
    'Alphabet',
    'Color',
    'Chest Measurement (in inches)',
    'Neck Measurement (in inches)',
    'Girth Measurement (in inches)',
    'Collar to Tail Measurement (in inches)',
    'Print Option',
    'Diner Height',
    'Colour Options',
    'Name of your pet',
    'Print Options',
    'Bed Colour',
    'Cushion Shape',
    'Bandana Size',
    'Bandana Colour',
    'Biscuits',
    'Colour/Fabric Options',
    'Earmuff',
    'Earmuff Size',
    'Bow Tie',
    'Name/Text',
    'Alphabet Type',
    'Add Paw or Bone',
    'Paw or Bone',
    'Text To Be Engraved',
    'Dial Engraving',
    'Back Case Engraving',
    'Crown Engraving',
    'Upper Text',
    'Lower Text',
    'Your Number Plate Info',
    'Text On front Side',
    'Text On Left Side',
    'Text On Back Side',
    'Text On Right Side',
    'Text on Her Pendant',
    'Text on His Pendant',
    'Dial Engraving for her',
    'Dial Engraving for him',
    'Buckle Engraving for her',
    'Buckle Engraving for him',
    'Back Case Engraving for her',
    'Back Case Engraving for Him',
    'Crown Engraving for her',
    'Crown Engraving for him',
    'Her Bracelet Text',
    'His Bracelet Text',
    'Signature Image',
    'Charm Engraving',
    'Left Side Customization',
    'Right Side Customization',
    'Left Side Letter',
    'Right Side Letter',
  ],
};
export const DeliverAddress = {
  title: 'Deliver to',
  buttonText: 'Change',
};
export const ShippingMethod = {
  title: 'Shipping method',
  error: 'Please select shipping method',
  reCalculating: 'Please wait, Recalculating Shipping',
  eddToBeShown: 'Enter PIN code to get Estimated Delivery Date',
};
export const Discounts = {
  inputPlaceholder: 'Enter coupon code',
  flitzTitle: 'Reward Points',
  viewOffers: 'View All',
  viewAllCoupons: 'View all coupons',
  offersSheetHeading: 'Coupons & Offers',
  messages: {
    invalidCode: 'Invalid discount code! Please check the offer details.',
    invalidChannel: 'This code is only applicable on',
  },
  apply: 'Apply',
  paytmCashback: ' Paytm Wallet cashback. T&Cs apply',
  offerNotValid: 'Offer not valid on entered card',
  viewCoupon: 'Click here to View Coupons',
  speciallyForYou: 'Specially For You',
};
export const GiftCards = {
  applyBtn: 'Apply',
  removeBtn: 'Remove',
  redeemAnother: 'Redeem another',
  bottomSheetTitle: 'Gift Card',
  giftCardPreApply: 'Have Gift Card?',
  inputPlaceholder: 'Enter Gift Card Code',
  giftCardProviderName: 'qwik_cilver',
  giftPinInputPlaceholder: 'Enter Six Digit Pin',
  redeemedVia: 'Via gift card ending with',
  addressChange:
    'Gift card(s) were removed because of a change in email id attached to the address. Please try reapplying after changing the email id in the address.',
};
export const ShoppingBag = {
  title: 'Products in Shopping Bag',
};
export const ButtonText = {
  continue: 'Continue',
};

export const Color = {
  white: ' #fff',
  testColor: 'blue',
};

export const OrderPendingPage = {
  title: 'Order Payment pending!',
  para: 'Order confirmation pending! Wait for the notification.',
  card: 'We didn’t receive any response from your bank, rest assured, any money that has been deducted will be refunded within 3-5 days',
  btntxt: 'Try again',
  error: 'Something went wrong! try again or contact support.',
  retry: 'RETRY',
  chooseAnotherMethod: 'RETRY PAYMENT',
  enterOtpAgain: 'Enter OTP again',
};

export const APIErrorHandling = {
  generic: 'Something went wrong! try again or contact support.',
  pincodeError: 'Pincode not serviceable.',
};

export const CustomErrors = {
  invalidPaymentMethods: 'Products in the cart are not eligible for cash on delivery.',
  invalidAddress: 'Address is mandatory. Please enter the same to continue',
};

export const upiPaymentFail = {
  steps: [
    'Open the SMS sent you from GoKwik',
    'Click on the payment link',
    'Select any UPI App and Complete the Transaction',
  ],
  failMessage:
    'Looks like there has been a problem opening your UPI Intent. Complete your payment seamlessly with the payment link sent to you.',
  otpSubtitle: 'You will get a payment link on',
  note: 'The link in the message will start with',
  transactionNotText: 'Transaction failed! Try again or use another method.',
  differentPaymentMethodText: 'Please try again with a different payment method.',
  differentPaymentMethodBtnText: 'Retry Payment',
};
export const removeDiscountConfirmation = {
  loyaltyHeading: 'Loyalty points can’t be clubbed with brand offer',
  loyaltySubHeading: 'Loyalty points will be removed',
  notClubbedWith: 'can not be clubbed with',
  willBeRemoved: 'will be removed',
  willBeReplaced: 'will be replaced',
  yesRemove: 'Yes, remove',
  yesReplace: 'Yes, replace',
  alert: 'Will be Removed. Are You Sure?',
  yes: 'Yes',
  no: 'No',
  gotIt: 'Got it!',
};
export const PaymentConfirmPopup = {
  promptmsg: 'You might lose out on a extra discount after exiting',
  promptAlert: 'Are you sure you want to exit?',
  discountMsg: 'You might miss out on savings of',
  freeGiftMsg: 'You might miss out on',
  freeGiftText: ' Free Gift',
  commonMsg: 'Products in huge demand',
  commonSubtext: 'might run',
  outOfStock: 'Out of Stock',
  alert: 'Are you sure you want to cancel payment?',
  btnYes: 'Yes',
  btnNo: 'No',
  customFreeGiftMsg: 'You will lose out on Free Gift and savings of',
  customMsg: 'You will lose out on savings of',
  exitMessage: [
    { reason: 'I found a better price or product elsewhere', bucket: 'Price' },
    { reason: 'I want to add or modify items in my cart', bucket: 'Cart' },
    { reason: 'I find pricing too high or unclear', bucket: 'Price' },
    { reason: 'I am not sure about quality and return/exchange policy', bucket: 'Trust' },
    { reason: 'I am facing issues in applying coupons', bucket: 'Offers' },
    { reason: 'I am not sure about the delivery dates', bucket: 'Delivery' },
    { reason: 'Others', bucket: 'Intent' },
  ],
  commonExitText: 'Let us know what went wrong.',
  continueTxt: 'Continue Shopping',
  skipTxt: 'Skip and exit',
  submitTxt: 'Submit and exit',
  headingTxt: 'Wait, are you sure?',
};

export const Payment = {
  paymentLink: 'Pay with Payment Link',
  paymentLinkSent: 'Link has been successfully sent to given mobile number.',
  completePayment: 'Complete the payment to place order.',
  payWithApps: 'Pay with app',
  debitCredit: 'Credit/Debit Cards',
  payWithLink: 'Pay with Payment link',
  codDisableProducts: 'Products in this cart are not eligible for COD',
  codDisableCart: 'Cash on Delivery is disabled for this cart',
  otpSent: 'OTP has been sent for authentication to mobile number registered with the bank',
  paymentSuccessText: 'Your order has already been placed successfully. You can safely close this popup and continue.',
  captureFailureText: 'Something went wrong, but no worries!',
  captureText: 'Please wait while we verify your payment status',
};
export const Notification = {
  text: 'Send me order updates & offers - (no spam)',
  tc: `By proceeding, I agree to Gokwik's`,
  allowProceed:
    'By proceeding, I am allowing Gokwik to pre-fill address and e-mail Id from their database for a seamless check-out experience.',
  checkToContinue: 'Please select the checkbox to continue',
  unsubscribe:
    'You will not receive order updates and other important communication. Please select this option to receive important updates.',
};
export const snackbarMessages = {
  validNumber: 'Please enter valid phone number',
  paymentLinkSent: 'Payment Link sent.',
  paymentLinkError: 'Oops! Something went wrong',
  otpSentFlag: 'OTP has been resent to your phone',
  loginOtpSentFlag: 'OTP sent on Whatsapp and SMS',
  shippingRetryMessage: 'Please apply the discount/loyalty code on Address Screen',
  incorrectOtp: 'The OTP you entered is incorrect. Please try again.',
  failedCaptcha:
    'Sorry, your validation was not successful.Please choose Pay online now option to complete your order.',
  failedToOpenNewWindow: 'Payment error! Try again or use a different browser.',
};

export const CardDetails = {
  addDetails: 'Add Card details',
  secureDetails: 'We will securely save your card details',
  saveDetails: 'Save card details securely with GoKwik for future use',
  waiting: 'Please wait as we confirm the transaction with your bank',
  waitingWithBank: 'Please wait as we confirm the transaction with',
  enterCvv: 'Enter CVV',
};

export const bottomSheetHeading = {
  addCard: 'Add new card',
  editCard: 'Edit card',
};
export const cardApiMessages = {
  successfulEdit: 'Card has been edited successfully',
  failedEdit: 'Failed to edit card',
  successfulAdd: 'Card has been added successfully',
  failedAdd: 'Failed to add the card! Verify details and try again.',
  submitOtpZero: 'Something went wrong. Please try another card',
  invalidDate: 'Invalid card expiry date! Verify details and try again.',
  sentOtp: 'The OTP has been sent your phone number',
  retryOrder: 'If you would like to try placing the order again please close and open the checkout',
  invalidCard: 'Invalid card number! Verify details and try again.',
  maxOtpAttempts: 'OTP attempts exceeded! Try again after some time.',
};

export const networkStatus = {
  offline: 'You’re offline! Check your internet and try again.',
  online: 'Back online!',
};
export const CouponList = {
  title: 'Apply Coupon',
  offers: {
    title: 'Brand Offers',
    appliedOffersTitle: 'Applied Offers',
    manualOffersTitle: 'Manual Offers',
    autoOffersTitle: 'Auto Offers',
    paymentTitle: 'Payment Offers',
    savedText: 'Saved',
    saveText: 'Save',
    getText: 'Get',
    tc: 'View T&C',
    btn: 'Apply',
    remove: 'Remove',
    applied: 'APPLIED',
    pay: 'PAY',
    notFound: 'Offer not found!',
    productMissing: 'Required item is missing from the cart',
    credMessage: '100 cashback on prepaid payments',
    couponApplied: 'Coupon applied',
  },
  subTitle: 'Auto applied with select payment method',
};
export const PaymentButtonTitle = {
  bnpl: 'Buy Now Pay Later',
  wallet: 'Wallets',
  netbanking: 'Netbanking',
  upi: 'UPI',
  cards: 'Debit/Credit Cards',
  cod: 'Cash on Delivery',
  credpay: 'CRED',
  placeOrder: 'Place Order',
  emi: 'EMI',
  bajajf: 'Bajaj Finserv EMI',
  ppcod: 'Cash on Delivery',
  shopifyRedirect: 'Other Payment Methods',
  lazypay: 'LazyPay',
  amazonpaylater: 'Amazon Pay Later',
  zestmoney: 'ZestMoney',
  tatapay: 'TataPay',
  snapmint: {
    mobile: '0% EMI on UPI & Cards',
    desktop: '0% EMI on UPI & Cards',
  },
  boat: {
    upi: 'UPI',
    cards: 'Debit/Credit Cards',
    wallets: 'Wallets',
    bnpl: 'Pay Later',
    netbanking: 'Net Banking',
  },
  bnplGokwik: 'Pay Later on UPI',
  simplpayin3: 'Simpl Pay in 3',
  simplpay: 'Simpl Pay Later',
};
store_netbankingObject.subscribe((res) => {
  if (res.status && res.text) PaymentButtonTitle['shopifyRedirect'] = res.text;
});

export const boatSubtext = {
  upi: 'Paytm, PhonePe, GPay',
  cards: 'Visa, Mastercard, Rupay',
  wallets: 'PhonePe, Amazon Pay, Paytm',
  cod: 'Additional fee charged for delivery',
  netbanking: 'Select from a list of banks',
  bnpl: 'Order now & Pay later at no extra cost',
};
export const AdoncMessage = {
  order_retry: {
    buttonText: 'Close the popup',
    heading: 'Placing your order',
    text: 'If your order is not placed within the next 4 hours,the payment will be refunded within 4-7 days.',
  },
  cart_verification_failed: {
    heading: 'Could not place order',
    text: 'Don’t worry, any money deducted will be automatically refunded within 4-7 days',
    buttonText: 'Retry placing order',
  },
  pending: {
    heading: 'Please wait while we verify the payment status.',
    text: 'We are verifying your payment status with our partners. We will complete the order if we get confirmation within 20 minutes, otherwise, any money deducted will be refunded within 3-5 days.',
    buttonText: 'Retry Payment',
    buttonImage: imageConstants.upi,
  },
  initiate: {
    heading: 'Please wait while we verify the payment status with the bank.',
    text: "Please wait while we verify your payment status. In case we don't receive payment confirmation within 20 minutes, any amount debited will be refunded within 4-7 working days",
    buttonText: 'Cancel',
    additionalText: 'Could not complete payment?',
    retryText: 'Retry Payment',
  },
};

export const stateAbbreviations = {
  'ANDAMAN AND NICOBAR ISLANDS': 'AN',
  'ANDHRA PRADESH': 'AP',
  'ARUNACHAL PRADESH': 'AR',
  ASSAM: 'AS',
  BIHAR: 'BR',
  CHANDIGARH: '	CH',
  CHHATTISGARH: '	CT',
  'DADRA AND NAGAR HAVELI': '	DN',
  'DAMAN AND DIU': 'DD',
  DELHI: 'DL',
  GOA: 'GA',
  GUJARAT: '	GJ',
  HARYANA: 'HR',
  'HIMACHAL PRADESH': 'HP',
  'JAMMU AND KASHMIR': 'JK',
  JHARKHAND: 'JH',
  KARNATAKA: 'KA',
  KERALA: 'KL',
  LAKSHADWEEP: 'LD',
  'MADHYA PRADESH': 'MP',
  MAHARASHTRA: 'MH',
  MANIPUR: 'MN',
  MEGHALAYA: 'ML',
  MIZORAM: 'MZ',
  NAGALAND: 'NL',
  ODISHA: 'OR',
  ORISSA: 'OR',
  PUDUCHERRY: 'PY',
  PUNJAB: 'PB',
  RAJASTHAN: 'RJ',
  SIKKIM: 'SK',
  'TAMIL NADU': 'TN',
  TELANGANA: 'TG',
  TRIPURA: 'TR',
  'UTTAR PRADESH': 'UP',
  UTTARAKHAND: 'UT',
  UTTARANCHAL: 'UT',
  'WEST BENGAL': 'WB',
};

export const paymentContent = {
  title: 'Payment Options',
  error: 'Something went wrong please try again',
  placeOrder: 'Please click on Place order to complete your order',
  selectPayment: 'Please select payment method to complete the order',
};

export const confirmationBoxText = {
  title: 'Confirm Your order',
  subTitle: 'Your COD order will be placed. Are you sure?',
};

export const badgeTitle = {
  upi: 'Get {amount} discount',
  cod: '\u20B9{charges} COD fee added',
  cards: 'Get {amount} discount',
  wallet: 'Get {amount} discount',
  bnpl: 'Get {amount} discount',
  emi: 'Get {amount} discount',
  ppcod: '',
  netbanking: 'Get {amount} discount',
  credpay: 'instant and secure payments with CRED',
  snapmint: 'Get {amount} discount',
  bharatxpay: '{amount} OFF on BNPL via UPI',
  lazypay: 'Get {amount} discount',
  amazonpaylater: 'Get {amount} discount',
  bnpldefault: 'Buy Now Pay Later',
};

export const savedCardTexts = {
  title: 'Delete this card?',
  body: 'This card will be removed from your saved payment methods.',
};

export const cardEmiTitle = {
  checkEligibility: 'Enter card number to check eligibility',
  ccDcEmi: 'Credit/Debit Card EMI ',
  viewPlans: 'View All Plans',
  checkEligibilityBtn: 'Check Eligibility for New Card',
  chooseEmi: 'Choose an EMI Plan',
  chooseEmiOptions: 'Choose EMI Options',
  addCard: 'Add Card',
  cardLimit: 'Your card limit will be temporarily utilised for Rs.{amount}',
  bankConversion: 'Your bank will take 7-8 days to convert this to an EMI',
  noCostEmi:
    'Interest of Rs.{amount} charged by your bank has already been reduced as No Cost EMI offer from the order amount',
  noCostEmiInfo: "You'll get an upfront No Cost EMI discount to cover the interest charged by your bank",
  infoText:
    'Please get in touch with your bank for interest rate, processing fees, refund or pre-closure related queries',
  cardMisMatch: 'Card Mismatch',
  cardMismatchMessage: 'No EMI plans available with this card',
  similarPlanMessage: 'Similar plan available with this card',
  multiplePlanMessage: 'Similar plans available with this card',
  noOfferAvailable: 'No offer available on this bank card',
  similarOfferAvailable: 'One similar offer available with this card',
  cardMismatchInfo: 'It seems that the card you have entered is of a different bank',
  offerMismatchInfo: 'Offer {offerId} worth ₹{amount} has been removed',
  cardMismatchHeading: 'Card Mismatch',
  offerMismatchHeading: 'Offer is not available on this card',
  emiBreakdownInfo:
    'Your bank might charge one-time processing fee. Please get in touch with your bank for processing fee or pre-closure related information',
  getInstantDiscount: 'Get Instant Bank Discount of {amount}',
  instantDiscountApplied: 'Instant Bank Discount of {amount} Applied!',
  OfferAvailable: 'One offer available with this card',
};
export const netBankingText = {
  title: 'Select Your Bank',
  netbanking: 'Netbanking',
  facingIssues: 'Facing issues currently',
  selectDifferentBank: 'Select Different Bank',
  popular: 'Popular Banks',
  others: 'Other Banks',
  notFound: 'No Banks Found',
};

export const paymentMethodNotApplicable = {
  appliedOfer: 'The offer you applied only works with',
  proccedWith: 'Do you want to proceed with',
  removeApplied: 'this will remove applied offer',
  proceed: 'Proceed',
  no: 'No',
};

export const retryModalText = {
  retryErrorMessage: 'Your transaction could not be completed at this time.',
  tryAgain: 'Please try again to complete your purchase',
  retryBtn: 'Retry Payment',
  chooseAnotherMethod: 'Retry Payment',
  privacyPolicyText:
    'By continuing you consent to share your truecaller profile information with Gokwik, and agree to Gokwik’s Privacy policy and terms of conditions',
};

export const snapmintText = {
  redirectToSnapmint: 'You are being redirected to Snapmint.',
  convinienceText:
    'For your convenience your personal details including your name, phone, email and shipping details will be shared',
  continue: 'Continue',
  swr: 'Something went wrong',
  payViaSnapmint: 'Pay via Snapmint',
  transactionNotText: 'Your transaction could not be completed at this time.',
  differentPaymentMethodText: 'Please try again with a different payment method.',
  differentPaymentMethodBtnText: 'Retry Payment',
  emis: 'EMIs',
  now: 'Now',
  emiText: 'months EMI, No Card required',
  subText: 'Instant Approval • Snapmint',
  payLaterText: 'Rest Later',
};

export const bharatxText = {
  redirectTobharatx: 'You are being redirected to BharatX.',
  transactionNotText: 'Your transaction could not be completed at this time.',
  differentPaymentMethodText: 'Please try again with a different payment method.',
  differentPaymentMethodBtnText: 'Retry Payment',
  continue: 'Continue',
  swr: 'Something went wrong',
  now: 'Now',
  later: 'Rest Later',
  subText: 'Pay in 3 installments',
};

export const credpayText = {
  subText: 'Saved cards, UPI & pay later',
};

export const paymentHeader = {
  edit: 'Edit',
  addNew: 'Add New',
  plusSymbol: '+',
};
export const emiBankName = {
  AMEX: 'American Express Bank',
  AUSFB: 'AU Small Finance Bank',
  AXIS: 'AXIS Bank',
  BOB: 'Bank of Baroda',
  CBOI: 'Central Bank of India',
  CITI: 'Citibank',
  CORP: 'Corporation Bank',
  HDFC: 'HDFC Bank',
  HSBC: 'HSBC',
  ICICI: 'ICICI Bank',
  IDBI: 'IDBI Bank',
  IDFC: 'IDBI First Bank',
  INDUS: 'Indus Ind Bank',
  KOTAK: 'Kotak Mahindra Bank',
  ONEC: 'One Card',
  RBL: 'RBL Bank',
  SCB: 'Standard Chartered Bank',
  SBI: 'State Bank of India',
  YES: 'Yes Bank',
  FDRL: 'Federal Bank',
  BJFS: 'Bajaj Finserv',
  KBEE: 'KreditBee',
  LIQL: 'LiquiLoan',
  ZEST: 'ZestMoney',
};

export const codConfirmationPromptTexts = {
  promptMessage1Text: 'Confirm cash on delivery of',
  promptMessage2Text: 'Are you sure you want to proceed with Cash on Delivery for your order?',
  promptMessage3Text: 'Confirm',
  promptMessage4Text: 'Pay online now',
  navigateToPayment: 'payment',
  navigateToUPI: 'upi',
};

export const offerStrip = {
  msg: 'Complete login to get more offers',
  errorMsg: 'A discount is already applied, please remove it to view more offers',
  newOffers: 'new offers available. Check Now',
  movieSubtext: 'Please check your email after 15th July 2023.',
  movieTitle: 'Congrats! You have won',
};
export const offerBanner = {
  title: 'Extra discount available at "Payment" step',
};

export const twidPayText = {
  codNotAllowed: 'Rewards are not applicable for COD Orders. Do you want to continue with COD Order?',
};

export const codTimerTexts = {
  promptMessage1Text: 'Confirm cash on delivery of',
  promptMessage2Text: 'Placing your Cash on Delivery order automatically',
  promptMessage3Text: 'I Don`t want to save',
  promptMessage4Text: 'I Want to save {x} ',
  navigateToPayment: 'payment',
  navigateToUPI: 'upi',
  timer: 30,
};
export const OrderConfirmationMsg = 'High demand! Order confirmation may take 1-2 hours.';
export const snapchatEvents = {
  addBilling: 'ADD_BILLING',
  initiateCheckout: 'START_CHECKOUT',
  purchase: 'PURCHASE',
};

export const OrderSummaryTitle = {
  subtotal: 'Subtotal',
  totalDiscount: 'Total Discount',
  couponDiscount: 'Coupon Discount',
  prepaidDiscount: 'Prepaid Discount',
  shipping: 'Shipping',
  tax: 'Tax',
  codFee: 'COD Charges',
  giftCard: 'Gift Card total',
  twid: 'Twid Pay Reward',
  ppcod: 'Payable on Delivery',
  toPay: 'To Pay',
  shopify_store_credits: 'Store Credits Used',
  totalMrp: 'MRP Total',
  totalDiscountOnMrp: 'Discount on MRP',
  ePayReward: 'e-pay Reward',
  specialDiscount: 'Special Discount',
  automaticDiscount: 'Automatic Discount',
  loyaltyDiscount: 'Loyalty Discount',
  giftCardAndRewards: 'Gift Card and Rewards',
};

export const ga4Events = {
  orderSummary: 'order_summary_clicked_gk',
  mobileNumberEnter: 'mobile_number_entered_gk',
  otpSent: 'otp_sent_gk',
  otpEnter: 'otp_entered_gk',
  otpVerify: 'otp_verified_gk',
  editAddress: 'edit_address_clicked_gk',
  editMobile: 'edit_mobile_clicked_gk',
  addAddressPage: 'add_address_page_landed_gk',
  addAddressContinue: 'add_address_continue_gk',
};

export const customMetaEvents = {
  cod: 'Custom_purchase_cod',
  prepaid: 'Custom_purchase_prepaid',
  new_customer: 'Custom_purchase_new_customer',
  repeat_customer: 'Custom_purchase_repeat_customer',
  multiple_products: 'Custom_purchase_multiple_products',
  single_product: 'Custom_purchase_single_product',
  non_high_risk: 'Custom_purchase_non_high_risk',
  high_order_value: 'Custom_purchase_high_order_value',
};

export const gtmEvents = {
  login_landed: 'login_step_landed',
  otp_landed: 'otp_step_landed',
  add_address_landed: 'add_address_step_landed',
  edit_address_landed: 'edit_address_step_landed',
  address_listing: 'listing_step_landed',
  payment_step_landed: 'payment_step_landed',
  payment_step_rendered: 'payment_step_rendered',
  view_order_summary: 'view_order_summary',
  view_offers_click: 'view_offers_click',
  coupon_applied_success: 'coupon_applied_success',
  coupon_applied_failed: 'coupon_applied_failed',
  coupon_removed: 'coupon_removed',
  gift_card_click: 'gift_card_click',
  gift_card_apply: 'gift_card_apply',
  gift_card_remove: 'gift_card_remove',
  checkout_close_popup: 'checkout_close_popup',
  offer_banner_loaded: 'offer_banner_loaded',
  discount_drawer_toggled: 'discount_drawer_toggled',
  listing_step_rendered: 'listing_step_rendered',
  address_selected: 'address_selected',
  estimated_delivery_date_set: 'estimated_delivery_date_set',
  offers_fetched: 'offers_fetched',
  automatic_discount_applied: 'automatic_discount_applied',
};
export const upiCollectText = {
  enterUpiId: 'Please enter your UPI ID',
  payViaId: 'Pay via UPI ID',
  invalidUpiId: 'Invalid UPI ID',
  failedToValidateId: 'Failed to validate UPI ID',
  paymentRequestText: 'You will receive payment request on your UPI App',
  safeAndSecure: '100% safe and secure payments',
  warningText: 'Do not hit back until transaction is completed',
  pageExpiresIn: 'Expires in',
  discountMsg: 'You are saving ₹{discount} with UPI Payment',
  swr: 'Something went wrong',
  transactionNotText:
    'Your transaction could not be completed at this time. Please try again with a different payment method.',
  differentPaymentMethodBtnText: 'Retry Payment',
  steps: ['Go to your UPI App', 'Select the payment request', 'Enter UPI PIN to complete payment'],
  suggestionText:
    'Your browser might not support opening UPI App directly. Please enter UPI ID to receive payment request',
};

export const HIDE_COD_REASONS = [
  'Products in this cart are not eligible for COD.',
  'CoD is not available for the products in your cart.',
  'COD unavailable',
  'Your confirmed CoD order is already is in transit. Please wait till this order gets delivered',
];

export const ONPL_BACK_OPTIONS = [
  { label: 'Cancel order', value: 'cancel' },
  { label: 'Pay on delivery', value: 'cod_payment' },
];

export const ONPL_STATUS_TEXT = {
  pending: 'If you retry payment or choose COD, any debited amount will be refunded within 4-7 working days.',
  fail: 'Your payment could not be completed.',
};

export const ONPL_TEXT = {
  paymentReceived: 'We have received your payment',
  timerLable1: "Don't worry. Placing your order on COD",
  timerLable2: 'We will cancel the order in case your payment is not completed',
  rertyPayment: 'Retry Payment',
  codPayment: 'Confirm Now',
  payViaUpi: 'Pay via UPI',
  payViaCard: 'Pay via Card',
  paymentSuccess: 'Payment Success',
  paymentPending: 'Payment Pending',
  paymentFailed: 'Payment failed! Check details or use another method.',
  offersNotApplicable: 'Prepaid offers not applicable',
  codWaivedOff: 'COD fees waived off!',
};

export const codCaptchaTexts = {
  captchaMessage1Text: 'Confirm Your order',
  captchaMessage3Text: 'Confirm',
  captchaMessage4Text: 'Pay online now',
};

export const otpPageText = {
  confirmPayment: 'Confirm Payment',
  termsAndPolicy: 'Terms & Policy',
  byClickingOn: 'By clicking on',
  youAccept: 'you accept',
  somethingWentWrong: 'Something went wrong. Please try again.',
  exhaustedOtpAttempts: 'OTP limit reached! Wait before trying again.',
  exhaustedResendOtpAttempts: 'OTP resend limit reached! Wait before trying again.',
  otpExpired: 'OTP expired! Request a new OTP to proceed.',
  attemptsLeft: 'attempts left',
  resendOtp: 'Resend OTP',
  otpInvalid: 'The OTP you entered is incorrect. Please try again.',
  failedToSendOtp: 'Failed to send OTP! Check connection and retry.',
  otpSessionExpired: 'Your OTP session has expired. Please try again or choose another payment method.',
  otpSent: 'OTP sent successfully',
  errorVerifyingOtp: 'There was an error verifying the OTP. Please try again.',
  invalidOtp: 'The OTP you entered is incorrect. Please try again.',
  invalidOtpSmall: 'Invalid OTP',
  addressFound: 'We have found your address',
};

export const tatapayText = {
  bnplTatapay: 'bnpl-tatapay',
  tatapay: 'tatapay',
  tataPaylater: 'Tata Pay Later',
  availableLimit: 'Available Limit',
};

export const lazypayText = {
  bnplLazypay: 'bnpl-lazypay',
  lazypay: 'lazypay',
  lazypayHeader: 'Lazypay',
};

export const bajajpayText = {
  walletBajajpay: 'wallet-bajajpay',
  bajajpayHeader: 'Bajajpay',
};

export const amazonpaylaterText = {
  bnplAmazonpay: 'bnpl-amazonpay',
  amazonpaylater: 'amazonpaylater',
  amazonPaylater: 'Amazon Pay Later',
};

export const gokwikBnplText = {
  buttonLabel: 'Kwik EMI on UPI',
  methodName: 'bnplGokwik',
  infoText: 'You will receive payment link to pay remaining installments 5 days before due date',
  now: 'Now',
  twoEmis: '2 EMIs',
  noInterest: '0% interest & No hidden charges',
};

export const simplPayin3Text = {
  buttonLabel: 'Simpl Pay in 3',
  methodName: 'simplpayin3',
  now: 'Now',
  twoEmis: '2 EMIs',
  noInterest: '0% Interest, ₹0 charges',
  simplPayin3: 'Simpl Pay In 3',
  differentPaymentMethodText: 'Please try again with a different payment method.',
  differentPaymentMethodBtnText: 'Retry Payment',
};

export const simplBnplText = {
  buttonLabel: 'Simpl Pay Later',
  methodName: 'bnpl-simplpay',
  subText: '1-Click Pay',
  simplpay: 'simplpay',
  bnplSimplPay: 'bnpl-simplpay',
  differentPaymentMethodText: 'Please try again with a different payment method.',
  differentPaymentMethodBtnText: 'Retry Payment',
};

export const TwidTextConstants = {
  otherPaymentOptions: 'Other Payment Options',
  payUsingOtherMethods: 'Pay Using Other Methods',
  pointsWontbeApplicable: "points won't be applicable with other payment methods",
  pointsNotApplicable: 'points are not applicable on entered card',
  rewardNotApplicableOnCard: 'Reward is not applicable on entered card',
};

export const buggyEmailList = {
  buggyEmailListExactMatch: [
    'rishabh@emailboox.com',
    'dominosorders@phonepe.com',
    'no-email@heallo.ai',
    'dummy@jublfood.com',
    'order@aqualens.in',
    'dummy@cred.club',
    'test@dominos.co.in',
    'admin@mylofamily.com',
    'pepijec919@konican.com',
    'nomail@gmail.com',
    'a@gmail.com',
    'haha@gmail.com',
    'customer@gmail.com',
    'msdka.55@gmail.com',
    'dummy@gokwik.co',
    'ayuvyauser@gmail.com',
    'gh@mail.com',
    's@gmail.com',
    'na@gmail.com',
  ],
  buggyEmailListContains: ['kindlyhealth', 'phonepe', 'dominos', 'jublfood', 'xyz', 'tested', 'test'],
};

export const discountText = {
  giftCard: 'Have a Gift Card? Click Here',
  loginToRedeem: 'Log in to redeem a gift card',
};
export const PrepaidCodTextConstants = {
  nonRefundable: 'Non-Refundable',
  payNow: 'Pay Now',
  upfrontFeesMessage: 'Upfront fees support merchant delivery costs',
  payRestOnDelivery: 'Pay rest on delivery',
};

export const gyftrTextConstants = {
  currentBalance: 'Current e-Pay balance',
  balance: 'e-pay balance',
  payWith: 'to your e-pay & use',
  reedemAmountError: 'Amount can not be greater than available balance or To Pay amount.',
  voucherLengthError: 'Voucher card length should be 16',
  voucherAdded: 'added to your e-pay balance and Entered amount will be deducted from your order total.',
  applied: 'amount will be deducted from your order',
  add: 'Add Balance',
  reedem: 'Reedem Vouchers',
  howItWork: 'How it works?',
  redeemTitle: 'Redeem e-pay balance',
  rechargeTitle: 'Add Vouchers to e-pay balance',
  redeemSubTitle: 'Enter the amount you want to redeem from your e-pay balance',
  rechargeSubTitle: 'Please enter your GyFTR voucher code to top up your balance',
  balanceTitle: 'Add voucher to e-pay balance',
  voucherCodeLabel: 'Enter voucher code',
  redeemAmountLabel: 'Enter the amount to redeem',
  addGiftCard: 'Add',
  redeemBalance: 'Redeem',
  addBalance: '+ Add Balance',
  redeemHeading: 'E-pay / Gift vouchers',
};
export const GokwikEventsText = {
  checkout_initiated: 'checkout_initiated',
};
export const invalidEasyRewardPoints =
  'There was an issue with loyalty points redemption. We have automatically applied the points for your convenience. Please select your preferred payment method to complete the purchase';
export const alertsText = {
  generic: 'Facing high failures',
};

export const GST = {
  error_message: 'Failed to fetch GST details',
  input_placeholder: 'Enter 15-character GSTIN',
  billing_info: 'This address will be used as your billing address',
  name: 'Registered Name',
  address: 'Billing Address',
  gst_text_login: 'Add GST at next step',
  address_label: 'Enter 6-Digit Pincode',
  billing_address_title: 'BILLING ADDRESS',
  same_as_address: 'Same as delivery address',
  add_gst: 'Add GST/Billing',
  confirm: 'Confirm',
  title: 'Add GST',
};

export const healthService = {
  apiError: 'Technical issue detected! Please try again later.',
  userFacingMessage: 'Hang on, loading your checkout...',
};

export const ShopifyStoreCredits = {
  creditsDisplayName: 'Store Credits',
  userFacingMessage: 'Hang on, loading your checkout...',
};

export const SnapmintOnBoardingTexts = {
  message: 'You will be redirected to bank page',
  payWithUpi: 'Pay with UPI or Cards',
  noCost: 'Enjoy at No Extra Cost',
  noInterest: 'Interest Free Installments',
  emiOptionsAvailable: 'Months EMI options are also available',
};

export const AlternateUpiNames = {
  other: 'Any UPI',
  credpay: 'CRED pay',
  tez: 'Google Pay',
};

export const PopUpText = {
  heading: 'Important Update!',
  text: 'Your email ID was different from what you’ve used to login on the website. We have updated the same',
};

export const cartReloadPopUpText = {
  heading: 'Cart Updated',
  allItemsOutOfStockMessage: 'Cart has out-of-stock items. Remove them to proceed.',
};

export const automationStores = ['19g6jle2d5p3n', '19g6jll23cfiz'];

export const shareOptionTexts = {
  title: 'Request others to pay',
  info: 'Share this payment link with your friends and family ask them to make the payment for you',
  btnText: 'Send Payment Link',
};

export const shareSheetTexts = {
  title: 'Send UPI Payment Link of',
  discount: 'Discount Applied',
  info: {
    h1: 'Request someone else for payment',
    p1: 'Send link via WhatsApp or any other app',
    p1_alt: 'Send link to phone number',
    h2: 'Second person completes payment',
    p2: 'Order is automatically placed once payment is completed',
  },
  btn: {
    main: 'Share Payment Link',
    alt: 'Send Payment Link',
  },
  expiry: 'The link will expire in 20 minutes',
};
